/* eslint-disable */
import Vue from 'vue'
import { getShareData } from './set-aio-share'

import { query, hashQuery, build, is } from '@didi/webx-js'
import Toast from '../../components/toast.vue'
import { invokeEvent } from '../js/event/event-center/index'
import Fingerprint from 'fingerprintjs'

const ToastConstructor = Vue.extend(Toast)
/**
 * 设置标题方法，解决ios部分app无法动态设置标题的问题
 *
 * @author tianjingsi
 * @date 2019-09-29
 * @param {*} title
 */
export function setTitle (title) {
    document.title = title
    const ua = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(ua) && (/micromessenger/.test(ua) || /ddudriver/.test(ua))) {
        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.src = '//static.udache.com/gulfstream/webapp/css/image/sawtooth.png'
        iframe.style.height = 0
        iframe.style.width = 0
        iframe.style.position = 'absolute'
        iframe.style.top = 0
        iframe.style.left = 0

        const loaded = function loaded () {
            setTimeout(() => {
                iframe.removeEventListener('load', loaded)
                document.body.removeChild(iframe)
            }, 0)
        }
        iframe.addEventListener('load', loaded)
        document.body.appendChild(iframe)
    }
}
export function setGlobalData (res) {
    window.SCENES = res.scenes
    window.GLOBAL_DATA = res.global
    window.PROJECT_ID = res.id
    window.BUSINESS_DATA = res.businessData
    // 设置 aio
    window.__DATA__ = {}
    if (!__isServerRender__) {
        // 设置分享
        const shareData = getShareData(res.global.share)
        // 挂载分享信息到window上，AIO 在微信中拉起分享时需要
        window.__DATA__.shareData = shareData
        return shareData
    }
}

export function showToast (text, duration = 3000) {
    const toastDom = new ToastConstructor({
      el: document.createElement('div'),
      data () {
        return {
          text: text,
          showWrap: true,
          showContent: true
        }
      }
    })
    document.body.appendChild(toastDom.$el)
    // 提前 250ms 执行淡出动画(因为我们再css里面设置的隐藏动画持续是250ms)
    setTimeout(() => { toastDom.showContent = false }, duration - 1250)
    // 过了 duration 时间后隐藏整个组件
    setTimeout(() => { toastDom.showWrap = false }, duration)
}

export function setPubData (key, val) {
    window.store && window.store.commit('setPubData', { key,  val })
}

export function getPubData (key) {
    return window.store ? window.store.state.dataCenter[key] : undefined
}

let urlParams = null
export function getUrlParams () {
    try {
        if (__isServerRender__) return {}
        if (urlParams) return urlParams
        urlParams = Object.assign(query(), hashQuery())
        if (urlParams.uid) {
            delete urlParams.uid
        }
        return urlParams || {}
    } catch (error) {
        return getLocalUrlParams()
    }
}

export function getBranch () {
    const urlParams = getUrlParams()
    return urlParams?.biz || 'passenger'
}

export function isMobile () {
    if (__isServerRender__) return true
    return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
}

export function addH5UrlParams (url) {
    return build(url, { h5_url: window.location.href })
}
let fpUid = ''

export async function getFpUid () {
    if (fpUid) return String(fpUid)
    if (!__isServerRender__ && is('passenger,miniprogram,kfpassenger,hitchapp')) {
      let loginInfo = {}
      try {
        loginInfo = await invokeEvent('login')
      } catch (error) {
        console.log('error', error)
      }
      const { uid, token } = loginInfo
      const supportNativeBigInt = typeof BigInt === 'function'
      if (uid && window.BigInt && supportNativeBigInt) {
          fpUid = window.BigInt(uid) & window.BigInt(0xffffffffffff)
      }
      token && setPubData('token', token)
    }
    if (!fpUid) {
        fpUid = window.localStorage.getItem('uid_web')
        if (!fpUid) {
            fpUid = new Fingerprint({ canvas: true }).get()
            window.localStorage.setItem('uid_web', fpUid)
        }
    }
    setPubData('uid_web', String(fpUid))
    return String(fpUid || '')
}

export function getLocalUrlParams () {
    const query = window.location.search.substring(1)
    const arr = query.split('&')
    const urlParams = {}
    for (let i=0; i < arr.length; i++) {
        const [key, val] = arr[i].split('=')
        urlParams[key] = val
    }
    if (urlParams.uid) {
        delete urlParams.uid
    }
    return urlParams
}

export function getSlider (params) {
    const sliderMap = window?.store?.state?.sliderMap || {}
    const { banner_num, zj_id } = params
    const tragetSlider = sliderMap[zj_id] || {}
    const { len, banners = [] } = tragetSlider
    return (len && banners.length < len && banners.indexOf(banner_num) === -1) ? tragetSlider : null
}
